module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("外管工作台")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("主管管理")])], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.loading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sum-grid"
  }, _vm._l((_vm.summaryCards), function(item) {
    return _c('div', {
      key: item.key,
      staticClass: "sum-card"
    }, [_c('div', {
      staticClass: "sum-label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('div', {
      staticClass: "sum-value"
    }, [_vm._v(_vm._s(item.value))]), _vm._v(" "), _c('div', {
      staticClass: "sum-foot"
    }, [_vm._v(_vm._s(item.foot))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-title"
  }, [_vm._v("动作闭环检查")]), _vm._v(" "), _c('div', {
    staticClass: "group-grid"
  }, [_vm._l((_vm.groupCards), function(g) {
    return _c('div', {
      key: g.key,
      staticClass: "group-card"
    }, [_c('div', {
      staticClass: "group-head"
    }, [_c('span', {
      staticClass: "group-label"
    }, [_vm._v(_vm._s(g.label))]), _vm._v(" "), _c('span', {
      staticClass: "group-open",
      class: {
        'is-danger': _vm.num(g.open) > 0
      }
    }, [_vm._v(_vm._s(_vm.num(g.open))), _c('i', [_vm._v(_vm._s(g.unit || '项'))])])]), _vm._v(" "), (g.rate != null) ? _c('div', {
      staticClass: "group-rate"
    }, [_vm._v("闭环率 "), _c('b', [_vm._v(_vm._s(_vm.formatRate(g.rate)))])]) : _vm._e(), _vm._v(" "), (g.mode === 'rate') ? _c('div', {
      staticClass: "group-meta"
    }, [_vm._v("应完成 " + _vm._s(_vm.num(g.due)) + " · 已完成 " + _vm._s(_vm.num(g.done)))]) : _vm._e(), _vm._v(" "), (g.extra) ? _c('div', {
      staticClass: "group-extra"
    }, [_vm._v(_vm._s(g.extra))]) : _vm._e(), _vm._v(" "), (_vm.num(g.soon) > 0) ? _c('div', {
      staticClass: "group-extra"
    }, [_vm._v("另 " + _vm._s(_vm.num(g.soon)) + " 项临近")]) : _vm._e(), _vm._v(" "), (_vm.num(g.overdueMax) > 0) ? _c('div', {
      staticClass: "group-extra"
    }, [_vm._v("最长逾期 " + _vm._s(_vm.num(g.overdueMax)) + " 天")]) : _vm._e()])
  }), _vm._v(" "), (!_vm.groupCards.length) ? _c('div', {
    staticClass: "group-empty"
  }, [_vm._v("暂无动作数据")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-title"
  }, [_vm._v("外管执行看板")]), _vm._v(" "), _c('div', {
    staticClass: "block-note"
  }, [_vm._v("按未闭环合计从多到少")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.operatorColumns,
      "data": _vm.operatorRows,
      "loading": _vm.loading,
      "stripe": "",
      "no-data-text": "暂无外管数据"
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "detailBlock",
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-title"
  }, [_vm._v("\n      未闭环明细\n      "), _c('span', {
    staticClass: "block-desc"
  }, [_vm._v("共 " + _vm._s(_vm.filteredItems.length) + " 项")])]), _vm._v(" "), _c('div', {
    staticClass: "filter-bar"
  }, [_c('span', {
    staticClass: "toolbar-label"
  }, [_vm._v("动作类型")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "160px"
    },
    model: {
      value: (_vm.kindFilter),
      callback: function($$v) {
        _vm.kindFilter = $$v
      },
      expression: "kindFilter"
    }
  }, [_c('Option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("全部动作")]), _vm._v(" "), _vm._l((_vm.kindOptions), function(item) {
    return _c('Option', {
      key: item.key,
      attrs: {
        "value": item.key
      }
    }, [_vm._v(_vm._s(item.label))])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "toolbar-label"
  }, [_vm._v("外管")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.operatorFilter),
      callback: function($$v) {
        _vm.operatorFilter = $$v
      },
      expression: "operatorFilter"
    }
  }, [_c('Option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("全部外管")]), _vm._v(" "), _vm._l((_vm.operatorOptions), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  })], 2), _vm._v(" "), (_vm.operatorFilter !== 'all' || _vm.kindFilter !== 'all') ? _c('Button', {
    on: {
      "click": _vm.resetFilter
    }
  }, [_vm._v("清除筛选")]) : _vm._e()], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.itemColumns,
      "data": _vm.filteredItems,
      "loading": _vm.loading,
      "stripe": "",
      "no-data-text": "当前筛选下无未闭环事项"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block settings-block"
  }, [_c('div', {
    staticClass: "block-title"
  }, [_vm._v("规则与设置")]), _vm._v(" "), _c('hr-workbench-settings', {
    attrs: {
      "embedded": ""
    }
  })], 1), _vm._v(" "), _c('review-save-modal', {
    attrs: {
      "value": _vm.modal.review,
      "row": _vm.modalRow
    },
    on: {
      "on-close": function($event) {
        _vm.modal.review = false
      },
      "on-success": _vm.load
    }
  }), _vm._v(" "), _c('followup-handle-modal', {
    attrs: {
      "value": _vm.modal.followup,
      "lessons": _vm.handleLessons
    },
    on: {
      "on-close": function($event) {
        _vm.modal.followup = false
      },
      "on-success": _vm.load
    }
  }), _vm._v(" "), _c('probation-decide-modal', {
    attrs: {
      "value": _vm.modal.probation,
      "row": _vm.modalRow
    },
    on: {
      "on-close": function($event) {
        _vm.modal.probation = false
      },
      "on-success": _vm.load
    }
  }), _vm._v(" "), _c('contract-renew-modal', {
    attrs: {
      "value": _vm.modal.contract,
      "row": _vm.modalRow
    },
    on: {
      "on-close": function($event) {
        _vm.modal.contract = false
      },
      "on-success": _vm.load
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchInfoId
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rule-bar"
  }, [_c('span', {
    staticClass: "rule-dot"
  }), _vm._v("\n    口径：始终统计全部在职外教，不受工作台外教运营筛选影响。可量化动作闭环率只看新外教回访与出勤跟进；试用期、合同只统计已逾期，临近项单独提示。\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d540468","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrWorkbench/HrWorkbenchSupervise.vue
// module id = 1754
// module chunks = 8